/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/time';
import '../../idmatch/service';
import '../../common/languages';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "legalentities": {
        "nested": {
          "verification": {
            "nested": {
              "Product": {
                "values": {
                  "PRODUCT_NOT_SET": 0,
                  "PAYMENTS": 1,
                  "PAYROLL_EMPLOYEE": 2,
                  "CAPITAL_BUSINESS_LOAN": 3,
                  "PAYROLL_EMPLOYER": 4,
                  "CAPITAL_CONSUMER_LOAN": 5,
                  "CASH_INVEST": 6,
                  "SFS_SAVINGS": 7,
                  "SQ_CHECKING": 8,
                  "AGNOSTIC": 99
                }
              },
              "Tier": {
                "values": {
                  "TIER_DO_NOT_USE": 0,
                  "PROVISIONAL": 1,
                  "FULL": 2
                }
              },
              "VerificationSignal": {
                "fields": {
                  "version": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 10,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 11,
                    "rule": "optional"
                  },
                  "manualReviewSignal": {
                    "type": ".squareup.legalentities.verification.VerificationSignal.ManualReview",
                    "id": 2
                  },
                  "informationRequiredSignal": {
                    "type": ".squareup.legalentities.verification.VerificationSignal.InformationRequired",
                    "id": 3
                  },
                  "ofacSignal": {
                    "type": ".squareup.legalentities.verification.VerificationSignal.OfacScreen",
                    "id": 4
                  },
                  "riskSignal": {
                    "type": ".squareup.legalentities.verification.VerificationSignal.Risk",
                    "id": 5
                  },
                  "idvSignal": {
                    "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification",
                    "id": 6
                  },
                  "legacySignal": {
                    "type": ".squareup.legalentities.verification.VerificationSignal.Legacy",
                    "id": 7
                  },
                  "provisionalSignal": {
                    "type": ".squareup.legalentities.verification.VerificationSignal.Provisional",
                    "id": 8
                  },
                  "agreementsSignal": {
                    "type": ".squareup.legalentities.verification.VerificationSignal.Agreements",
                    "id": 9
                  },
                  "complianceSignal": {
                    "type": ".squareup.legalentities.verification.VerificationSignal.Compliance",
                    "id": 12
                  },
                  "acceptanceSignal": {
                    "type": ".squareup.legalentities.verification.VerificationSignal.Acceptance",
                    "id": 13
                  },
                  "requestMetadataSignal": {
                    "type": ".squareup.legalentities.verification.VerificationSignal.RequestMetadata",
                    "id": 14
                  },
                  "bankDepositSignal": {
                    "type": ".squareup.legalentities.verification.VerificationSignal.BankDeposit",
                    "id": 15
                  },
                  "tinVerificationSignal": {
                    "type": ".squareup.legalentities.verification.VerificationSignal.TinVerification",
                    "id": 16
                  },
                  "docIdvSessionsSignal": {
                    "type": ".squareup.legalentities.verification.VerificationSignal.DocIdvSessions",
                    "id": 17
                  },
                  "businessVerificationSignal": {
                    "type": ".squareup.legalentities.verification.VerificationSignal.BusinessVerification",
                    "id": 18
                  },
                  "attributeMatchingSessionsSignal": {
                    "type": ".squareup.legalentities.verification.VerificationSignal.AttributeMatchingSessions",
                    "id": 19
                  },
                  "productLevelHardblockSignal": {
                    "type": ".squareup.legalentities.verification.ProductLevelHardblockCheck",
                    "id": 20
                  }
                },
                "nested": {
                  "ManualReview": {
                    "fields": {
                      "decision": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.ManualReview.Decision",
                        "id": 1,
                        "rule": "optional"
                      },
                      "comment": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "agentUid": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "productReviews": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.ManualReview.ProductReview",
                        "id": 4,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "Decision": {
                        "values": {
                          "UNDECIDED": 0,
                          "VERIFIED": 1,
                          "SUSPENDED": 2,
                          "IN_REVIEW": 3
                        }
                      },
                      "ProductReview": {
                        "fields": {
                          "product": {
                            "type": ".squareup.legalentities.verification.Product",
                            "id": 1,
                            "rule": "optional"
                          },
                          "decision": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.ManualReview.Decision",
                            "id": 2,
                            "rule": "optional"
                          },
                          "comment": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "agentUid": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "InformationRequired": {
                    "fields": {
                      "decision": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.InformationRequired.Decision",
                        "id": 1,
                        "rule": "optional"
                      },
                      "comment": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Decision": {
                        "values": {
                          "UNDECIDED": 0,
                          "SUBMITTED": 1,
                          "WAITING": 2
                        }
                      }
                    }
                  },
                  "OfacScreen": {
                    "fields": {
                      "decision": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.OfacScreen.Decision",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Decision": {
                        "values": {
                          "UNDECIDED": 0,
                          "CLEAR": 1,
                          "SUSPECTED": 2,
                          "HIT": 3,
                          "IN_PROGRESS": 4
                        }
                      }
                    }
                  },
                  "Risk": {
                    "fields": {
                      "decision": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.Risk.Decision",
                        "id": 1,
                        "rule": "optional"
                      },
                      "state": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.Risk.State",
                        "id": 2,
                        "rule": "optional"
                      },
                      "activationRiskLevel": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.Risk.Decision",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Decision": {
                        "values": {
                          "UNDECIDED": 0,
                          "UNKNOWN": 1,
                          "NO_RISK": 2,
                          "RISK": 3,
                          "SKIPPED": 4,
                          "TIN_BLOCKED": 5,
                          "TIMEOUT": 6,
                          "HIGH_RISK": 7,
                          "MEDIUM_RISK": 8
                        }
                      },
                      "State": {
                        "values": {
                          "STATE_DO_NOT_USE": 0,
                          "IN_PROGRESS": 1,
                          "COMPLETED": 2,
                          "NOT_READY": 3
                        }
                      }
                    }
                  },
                  "IdentityVerification": {
                    "fields": {
                      "state": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.State",
                        "id": 1,
                        "rule": "optional"
                      },
                      "results": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.Result",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "productDecisions": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision",
                        "id": 3,
                        "rule": "repeated"
                      },
                      "riskBased": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "State": {
                        "values": {
                          "STATE_DO_NOT_USE": 0,
                          "IN_PROGRESS": 1,
                          "COMPLETED": 2
                        }
                      },
                      "Result": {
                        "fields": {
                          "individualLegalentityToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "pollToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "attributes": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.Result.Attribute",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "irregularities": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.Result.IdentityIrregularity",
                            "id": 5,
                            "rule": "repeated"
                          },
                          "error": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.Result.IdmatchError",
                            "id": 6,
                            "rule": "optional"
                          },
                          "quizQuestions": {
                            "type": "int64",
                            "id": 7,
                            "rule": "optional"
                          },
                          "quizCorrect": {
                            "type": "int64",
                            "id": 8,
                            "rule": "optional"
                          },
                          "vendorDecision": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.Decision",
                            "id": 9,
                            "rule": "optional"
                          },
                          "idmatchQuizToken": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "idmatchVerifyToken": {
                            "type": "string",
                            "id": 11,
                            "rule": "optional"
                          },
                          "manualDecision": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.Decision",
                            "id": 12,
                            "rule": "optional"
                          },
                          "manualAgentUid": {
                            "type": "string",
                            "id": 13,
                            "rule": "optional"
                          },
                          "manualComment": {
                            "type": "string",
                            "id": 14,
                            "rule": "optional"
                          },
                          "identityverifierVerificationId": {
                            "type": "string",
                            "id": 15,
                            "rule": "optional"
                          },
                          "identityverifierResult": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.Result.IdentityverifierResult",
                            "id": 16,
                            "rule": "optional"
                          },
                          "identityverifierDecisionComment": {
                            "type": "string",
                            "id": 17,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "IdentityverifierResult": {
                            "values": {
                              "VERIFIED": 1,
                              "NOT_VERIFIED": 2,
                              "ERROR": 3
                            }
                          },
                          "IdmatchError": {
                            "fields": {
                              "reason": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "type": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "IdentityIrregularity": {
                            "values": {
                              "IRREGULARITIES_DO_NOT_USE": 0,
                              "DECEASED": 1,
                              "AGE_BELOW_MINIMUM": 2,
                              "OVERUSED_IDENTITY": 3,
                              "US_SSN_ISSUED_BEFORE_DOB": 4,
                              "DOB_MISMTACH": 5,
                              "INVALID_US_SSN": 6,
                              "FAILED_EQUIFAX_CREDIT_CHECK": 9,
                              "FAILED_EXPERIAN_CREDIT_CHECK": 10,
                              "INVALID_DOB": 11,
                              "ADDRESS_IS_PO_BOX": 12,
                              "ADDRESS_IS_GENERAL_DELIVERY": 13,
                              "FAILED_TRULIOO_CREDIT_CHECK": 14,
                              "MISKEYED_NAME": 15,
                              "FAILED_FINTRAC_CREDIT_CHECK": 16
                            }
                          },
                          "Attribute": {
                            "fields": {
                              "type": {
                                "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.Result.Attribute.Type",
                                "id": 1,
                                "rule": "optional"
                              },
                              "match": {
                                "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.Result.Attribute.Match",
                                "id": 2,
                                "rule": "optional"
                              },
                              "matchStrength": {
                                "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.Result.Attribute.MatchStrength",
                                "id": 3,
                                "rule": "optional"
                              },
                              "sources": {
                                "type": ".squareup.idmatch.service.Source",
                                "id": 4,
                                "rule": "repeated"
                              }
                            },
                            "nested": {
                              "Type": {
                                "values": {
                                  "KEY_DO_NOT_USE": 0,
                                  "NAME": 1,
                                  "DATE_OF_BIRTH": 2,
                                  "ADDRESS": 3,
                                  "US_SSN": 4,
                                  "CA_SIN": 5,
                                  "DOCUMENT_IDENTIFIER": 6,
                                  "BANK_ACCOUNT": 7,
                                  "BANK_ACCOUNT_NAME": 8,
                                  "POSTAL_CODE": 9,
                                  "PHONE_NUMBER": 10,
                                  "GOVERNMENT_DATA": 11
                                }
                              },
                              "Match": {
                                "values": {
                                  "MATCH_DO_NOT_USE": 0,
                                  "NO_MATCH": 1,
                                  "MATCH": 2
                                }
                              },
                              "MatchStrength": {
                                "values": {
                                  "UNKNOWN": 0,
                                  "UNMATCHED": 1,
                                  "EXACT": 2,
                                  "FUZZY": 3
                                }
                              }
                            }
                          }
                        }
                      },
                      "Decision": {
                        "values": {
                          "UNDECIDED": 0,
                          "APPROVED": 1,
                          "DECLINED": 2,
                          "OPTIMISTICALLY_APPROVED": 3,
                          "UNDER_REVIEW": 4,
                          "CUSTOMER_INFO_REQUIRED": 5,
                          "SUSPENDED": 6
                        }
                      },
                      "ProductDecision": {
                        "fields": {
                          "product": {
                            "type": ".squareup.legalentities.verification.Product",
                            "id": 1,
                            "rule": "optional"
                          },
                          "decision": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.Decision",
                            "id": 2,
                            "rule": "optional"
                          },
                          "individuals": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry",
                            "id": 4,
                            "keyType": "string"
                          },
                          "underReviewReason": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.UnderReviewReason",
                            "id": 5,
                            "rule": "optional"
                          },
                          "verificationDecisionResults": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.VerificationDecisionEvaluations",
                            "id": 18,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "IndividualEntry": {
                            "fields": {
                              "decision": {
                                "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.Decision",
                                "id": 1,
                                "rule": "optional"
                              },
                              "requestFlags": {
                                "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.RequestFlag",
                                "id": 2,
                                "rule": "repeated"
                              },
                              "reason": {
                                "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry.Reason",
                                "id": 3,
                                "rule": "repeated"
                              },
                              "idvRulesEvaluations": {
                                "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry.RuleEvaluation",
                                "id": 4,
                                "keyType": "string"
                              },
                              "idvAttemptCounter": {
                                "type": ".squareup.legalentities.verification.IdvAttemptCounter",
                                "id": 5,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "Reason": {
                                "fields": {
                                  "comment": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "code": {
                                    "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry.Reason.Code",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "fieldName": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "Code": {
                                    "values": {
                                      "DO_NOT_USE": 0,
                                      "FAILED_IDV": 1,
                                      "MATCHED_ATTRIBUTE": 2,
                                      "UNMATCHED_ATTRIBUTE": 3,
                                      "INVALID_ATTRIBUTE": 4,
                                      "OTHER": 5,
                                      "VENDOR_COMMENT": 6,
                                      "HAS_BLOCKING_IRREGULARITIES": 7,
                                      "DOCUMENT_VERIFICATION": 8
                                    }
                                  }
                                }
                              },
                              "RuleEvaluation": {
                                "fields": {
                                  "code": {
                                    "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry.RuleEvaluation.Code",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "reasons": {
                                    "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry.Reason",
                                    "id": 2,
                                    "rule": "repeated"
                                  }
                                },
                                "nested": {
                                  "Code": {
                                    "values": {
                                      "DO_NOT_USE": 0,
                                      "CRITERIA_MET": 1,
                                      "CRITERIA_NOT_MET": 2,
                                      "SKIP_EVALUATION": 3
                                    }
                                  }
                                }
                              }
                            }
                          },
                          "RequestFlag": {
                            "values": {
                              "REQUEST_FLAG_DO_NOT_USE": 0,
                              "QUIZ_REQUESTED": 1,
                              "FULL_SSN_REQUESTED": 2,
                              "DOC_IDV_REQUESTED": 3
                            }
                          },
                          "UnderReviewReason": {
                            "fields": {
                              "type": {
                                "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.UnderReviewReason.UnderReviewReasonType",
                                "id": 1,
                                "rule": "optional"
                              },
                              "details": {
                                "type": "string",
                                "id": 2,
                                "rule": "repeated"
                              }
                            },
                            "nested": {
                              "UnderReviewReasonType": {
                                "values": {
                                  "DO_NOT_USE": 0,
                                  "PARTNERSHIP_FAILED": 1,
                                  "BENEFICIAL_OWNER_FAILED": 2,
                                  "TRUST_FAST": 3,
                                  "TRUST_OPTIMISTIC": 4,
                                  "TRUST_MANUAL_REVIEW": 5,
                                  "ASSOCIATION_FAST": 6,
                                  "ASSOCIATION_OPTIMISTIC": 7,
                                  "ASSOCIATION_MANUAL_REVIEW": 8,
                                  "PRIMARY_FAILED_IDV": 9,
                                  "DIRECTOR_CRITERIA_NOT_MET": 10,
                                  "BENEFICIAL_OWNER_CRITERIA_NOT_MET": 11,
                                  "IDV_CRITERIA_MET": 12,
                                  "PARTNERSHIP_FAST": 13,
                                  "PARTNERSHIP_MANUAL_REVIEW": 14,
                                  "PARTNERS_CRITERIA_NOT_MET": 15,
                                  "INDIVIDUAL_CRITERIA_NOT_MET": 16,
                                  "FAILED_TO_VERIFY_BUSINESS_REGISTRATION_NUMBER": 17,
                                  "FAILED_TO_AUTOPOPULATE_BUSINESS_INFORMATION": 18,
                                  "BUSINESS_DATA_UPDATED_AFTER_BUSINESS_VERIFICATION": 19,
                                  "HAS_ADMINISTRATIVE_ACTION": 20,
                                  "PERSON_WITH_SIGNIFICANT_CONTROL_CRITERIA_NOT_MET": 21,
                                  "PERSON_WITH_SIGNIFICANT_CONTROL_FAILED": 22,
                                  "CHARITY_OR_NONPROFIT_MANUAL_REVIEW": 23
                                }
                              }
                            }
                          },
                          "VerificationDecisionEvaluations": {
                            "fields": {
                              "status": {
                                "type": ".squareup.legalentities.verification.VerificationDecision.Status",
                                "id": 1,
                                "rule": "optional"
                              },
                              "evaluations": {
                                "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.VerificationDecisionEvaluations.VerificationDecisionEvaluationsReason",
                                "id": 2,
                                "rule": "repeated"
                              }
                            },
                            "nested": {
                              "VerificationDecisionEvaluationsReason": {
                                "fields": {
                                  "status": {
                                    "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.VerificationDecisionEvaluations.VerificationDecisionEvaluationsReason.Status",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "details": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "Status": {
                                    "values": {
                                      "DO_NOT_USE": 0,
                                      "SUCCESS": 1,
                                      "FAILURE": 2
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  "Legacy": {
                    "fields": {
                      "createdBy": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "data": {
                        "type": "bytes",
                        "id": 2,
                        "rule": "optional"
                      },
                      "status": {
                        "type": ".squareup.legalentities.verification.VerificationDecision.Status",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "Provisional": {
                    "fields": {
                      "pending": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.Provisional.Pending",
                        "id": 1
                      },
                      "started": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.Provisional.Started",
                        "id": 2
                      },
                      "terminated": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.Provisional.Terminated",
                        "id": 3
                      }
                    },
                    "nested": {
                      "Pending": {
                        "fields": {}
                      },
                      "Started": {
                        "fields": {
                          "startDate": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 1,
                            "rule": "optional"
                          },
                          "expireDate": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "Terminated": {
                        "fields": {
                          "startDate": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 1,
                            "rule": "optional"
                          },
                          "endDate": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 2,
                            "rule": "optional"
                          },
                          "cause": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.Provisional.Terminated.Cause",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Cause": {
                            "values": {
                              "CAUSE_DO_NOT_USE": 0,
                              "PAYMENT_LIMIT_HIT": 1,
                              "EXPIRED": 2,
                              "UNUSED": 3,
                              "VERIFICATION_ATTEMPTED": 4,
                              "SUSPENDED": 5,
                              "HIGH_RISK": 6
                            }
                          }
                        }
                      },
                      "status": {
                        "oneof": ["pending", "started", "terminated"]
                      }
                    }
                  },
                  "Agreements": {
                    "fields": {
                      "agreements": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.Agreements.Agreement",
                        "id": 1,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "Agreement": {
                        "fields": {
                          "agreementId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "acceptedAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 2,
                            "rule": "optional"
                          },
                          "nodeToken": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "Compliance": {
                    "fields": {
                      "decision": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.Compliance.Decision",
                        "id": 1,
                        "rule": "optional"
                      },
                      "comment": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "agentUid": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "asynchronousScreenDecisions": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.Compliance.ProductDecision",
                        "id": 4,
                        "rule": "repeated"
                      },
                      "synchronousScreenDecisions": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.Compliance.ProductDecision",
                        "id": 5,
                        "rule": "repeated"
                      },
                      "state": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.Compliance.State",
                        "id": 6,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Decision": {
                        "values": {
                          "UNDECIDED": 0,
                          "CLEAR": 1,
                          "SUSPENDED": 2,
                          "UNDER_REVIEW": 3
                        }
                      },
                      "ProductDecision": {
                        "fields": {
                          "product": {
                            "type": ".squareup.legalentities.verification.Product",
                            "id": 1,
                            "rule": "optional"
                          },
                          "nodeDecisions": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.Compliance.Decision",
                            "id": 2,
                            "keyType": "string"
                          }
                        }
                      },
                      "State": {
                        "values": {
                          "STATE_DO_NOT_USE": 0,
                          "IN_PROGRESS": 1,
                          "COMPLETED": 2,
                          "TIMED_OUT": 3,
                          "ERROR": 4,
                          "PENDING": 5
                        }
                      }
                    }
                  },
                  "Acceptance": {
                    "fields": {
                      "decision": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.Acceptance.Decision",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Decision": {
                        "values": {
                          "UNDECIDED": 0,
                          "CLEAR": 1,
                          "SMCC_DECLINED": 2
                        }
                      }
                    }
                  },
                  "RequestMetadata": {
                    "fields": {
                      "onboard": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.RequestMetadata.Onboard",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Onboard": {
                        "fields": {
                          "business": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.RequestMetadata.Onboard.Business",
                            "id": 1,
                            "rule": "optional"
                          },
                          "client": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.RequestMetadata.Onboard.Client",
                            "id": 2,
                            "rule": "optional"
                          },
                          "languageCode": {
                            "type": ".squareup.common.languages.Language",
                            "id": 3,
                            "rule": "optional"
                          },
                          "merchantToken": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "personToken": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "unitToken": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Business": {
                            "fields": {
                              "category": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "subCategory": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "mcc": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              }
                            }
                          },
                          "Client": {
                            "fields": {
                              "anonymousVisitorToken": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "clientIpAddress": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "clientUserAgent": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "clientTimeZone": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              },
                              "clientDeviceId": {
                                "type": "string",
                                "id": 5,
                                "rule": "optional"
                              },
                              "multipassLoggableSessionToken": {
                                "type": "string",
                                "id": 6,
                                "rule": "optional"
                              },
                              "browserFingerprint": {
                                "type": "string",
                                "id": 7,
                                "rule": "optional"
                              },
                              "deviceInstallationId": {
                                "type": "string",
                                "id": 8,
                                "rule": "optional"
                              },
                              "avtCookie": {
                                "type": "string",
                                "id": 9,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  "BankDeposit": {
                    "fields": {
                      "decision": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.BankDeposit.Decision",
                        "id": 1,
                        "rule": "optional"
                      },
                      "state": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.BankDeposit.State",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Decision": {
                        "values": {
                          "UNDECIDED": 0,
                          "OPTIMISTICALLY_APPROVED": 1,
                          "APPROVED": 2
                        }
                      },
                      "State": {
                        "values": {
                          "STATE_DO_NOT_USE": 0,
                          "IN_PROGRESS": 1,
                          "COMPLETED": 2
                        }
                      }
                    }
                  },
                  "TinVerification": {
                    "fields": {
                      "state": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.TinVerification.State",
                        "id": 1,
                        "rule": "optional"
                      },
                      "results": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.TinVerification.Result",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "decision": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.TinVerification.Decision",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "State": {
                        "values": {
                          "STATE_DO_NOT_USE": 0,
                          "IN_PROGRESS": 1,
                          "COMPLETED": 2,
                          "TIMED_OUT": 3,
                          "ERROR": 4
                        }
                      },
                      "Decision": {
                        "values": {
                          "UNKNOWN": 0,
                          "VERIFIED": 1,
                          "UNVERIFIED": 2
                        }
                      },
                      "Result": {
                        "fields": {
                          "legalEntityNodeToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "decision": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.TinVerification.Decision",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "BusinessVerification": {
                    "fields": {
                      "businessVerificationState": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.BusinessVerification.BusinessVerificationState",
                        "id": 1,
                        "keyType": "string"
                      },
                      "state": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.BusinessVerification.State",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "State": {
                        "values": {
                          "STATE_DO_NOT_USE": 1,
                          "IN_PROGRESS": 2,
                          "COMPLETED": 4,
                          "ERROR": 5
                        }
                      },
                      "BusinessVerificationState": {
                        "fields": {
                          "productDecisions": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision",
                            "id": 2,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "ProductDecision": {
                            "fields": {
                              "product": {
                                "type": ".squareup.legalentities.verification.Product",
                                "id": 1,
                                "rule": "optional"
                              },
                              "productVerificationStatus": {
                                "type": ".squareup.legalentities.verification.VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Status",
                                "id": 8,
                                "rule": "optional"
                              },
                              "decisions": {
                                "type": ".squareup.legalentities.verification.VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Decision",
                                "id": 2,
                                "rule": "repeated"
                              }
                            },
                            "nested": {
                              "Decision": {
                                "fields": {
                                  "status": {
                                    "type": ".squareup.legalentities.verification.VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Decision.Status",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "verificationId": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "decisionType": {
                                    "type": ".squareup.legalentities.verification.VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Decision.Type",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "errorMessages": {
                                    "type": "string",
                                    "id": 4,
                                    "rule": "repeated"
                                  },
                                  "nonMatchedAttributes": {
                                    "type": ".squareup.legalentities.verification.VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Decision.Attribute",
                                    "id": 5,
                                    "rule": "repeated"
                                  },
                                  "matchedAttributes": {
                                    "type": ".squareup.legalentities.verification.VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Decision.Attribute",
                                    "id": 9,
                                    "rule": "repeated"
                                  },
                                  "comment": {
                                    "type": "string",
                                    "id": 6,
                                    "rule": "optional"
                                  },
                                  "matchType": {
                                    "type": ".squareup.legalentities.verification.VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Decision.MatchType",
                                    "id": 7,
                                    "rule": "optional"
                                  },
                                  "agentId": {
                                    "type": "string",
                                    "id": 8,
                                    "rule": "optional"
                                  }
                                },
                                "nested": {
                                  "Type": {
                                    "values": {
                                      "TYPE_DO_NOT_USE": 1,
                                      "BUSINESS_DATA": 2,
                                      "BENEFICIAL_OWNERS": 3,
                                      "PARTNERS": 4,
                                      "CORPORATE_DIRECTORS": 5
                                    }
                                  },
                                  "Status": {
                                    "values": {
                                      "STATUS_DO_NOT_USE": 1,
                                      "UNDECIDED": 2,
                                      "APPROVED": 3,
                                      "DECLINED": 4,
                                      "IN_PROGRESS": 5
                                    }
                                  },
                                  "Attribute": {
                                    "values": {
                                      "ATTRIBUTE_DO_NOT_USE": 1,
                                      "BRN": 2,
                                      "BUSINESS_NAME": 3,
                                      "ADDRESS": 4,
                                      "STREET_NAME": 5,
                                      "STREET_TYPE": 6,
                                      "LOCALITY": 7,
                                      "POSTAL_CODE": 8,
                                      "STATE_PROVINCE": 9,
                                      "BENEFICIAL_OWNER": 10,
                                      "DIRECTOR": 11,
                                      "BUILDING_NUMBER": 12,
                                      "EIN": 13,
                                      "BUSINESS_ID_CORPORATE_NUMBER": 14,
                                      "BUSINESS_ID_TRADE_RN": 15,
                                      "BUSINESS_ID_SIREN": 16,
                                      "BUSINESS_ID_SIRET": 17,
                                      "BUSINESS_ID_VAT": 18
                                    }
                                  },
                                  "MatchType": {
                                    "values": {
                                      "MATCH_TYPE_DO_NOT_USE": 1,
                                      "VENDOR_MATCH": 2,
                                      "MANUAL_OVERRIDE": 3
                                    }
                                  }
                                }
                              },
                              "Status": {
                                "values": {
                                  "STATUS_DO_NOT_USE": 1,
                                  "UNDECIDED": 2,
                                  "APPROVED": 3,
                                  "DECLINED": 4,
                                  "IN_PROGRESS": 5
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  "DocIdvSessions": {
                    "fields": {
                      "sessions": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.DocIdvSessions.DocIdvSession",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "historySessions": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.DocIdvSessions.DocIdvSession",
                        "id": 2,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "DocIdvSession": {
                        "fields": {
                          "nodeToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "verificationId": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "state": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.DocIdvSessions.DocIdvSession.State",
                            "id": 3,
                            "rule": "optional"
                          },
                          "vendorName": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "userFormUrl": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "sessionToken": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "product": {
                            "type": ".squareup.legalentities.verification.Product",
                            "id": 7,
                            "rule": "optional"
                          },
                          "resubmissionsRequested": {
                            "type": "int32",
                            "id": 8,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 9,
                            "rule": "optional"
                          },
                          "updatedAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 10,
                            "rule": "optional"
                          },
                          "comment": {
                            "type": "string",
                            "id": 11,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "State": {
                            "values": {
                              "STATE_DO_NOT_USE": 0,
                              "AWAITING_SUBMISSION": 1,
                              "COMPLETE_VERIFIED": 2,
                              "COMPLETE_NOT_VERIFIED": 3,
                              "SUBMITTED": 4,
                              "RESUBMISSION_REQUESTED": 5,
                              "COMPLETE_ATTRIBUTES_MISMATCH": 6
                            }
                          }
                        }
                      }
                    }
                  },
                  "AttributeMatchingSessions": {
                    "fields": {
                      "sessions": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "historySessions": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession",
                        "id": 2,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "AttributeMatchingSession": {
                        "fields": {
                          "nodeToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "structureToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "attemptNumber": {
                            "type": "int32",
                            "id": 3,
                            "rule": "optional"
                          },
                          "invalidatedVersion": {
                            "type": "int32",
                            "id": 4,
                            "rule": "optional"
                          },
                          "pollToken": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "state": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.State",
                            "id": 6,
                            "rule": "optional"
                          },
                          "product": {
                            "type": ".squareup.legalentities.verification.Product",
                            "id": 7,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 8,
                            "rule": "optional"
                          },
                          "updatedAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 9,
                            "rule": "optional"
                          },
                          "error": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.Error",
                            "id": 10,
                            "rule": "optional"
                          },
                          "vendorDecision": {
                            "type": "bool",
                            "id": 11,
                            "rule": "optional"
                          },
                          "quizQuestions": {
                            "type": "int32",
                            "id": 12,
                            "rule": "optional"
                          },
                          "quizCorrect": {
                            "type": "int32",
                            "id": 13,
                            "rule": "optional"
                          },
                          "irregularities": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.IdentityIrregularity",
                            "id": 14,
                            "rule": "repeated"
                          },
                          "attributes": {
                            "type": ".squareup.legalentities.verification.VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.Attribute",
                            "id": 15,
                            "rule": "repeated"
                          },
                          "comment": {
                            "type": "string",
                            "id": 16,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "State": {
                            "values": {
                              "STATE_DO_NOT_USE": 0,
                              "PENDING": 1,
                              "COMPLETE": 2,
                              "COMPLETE_MISMATCH": 3,
                              "PENDING_QUIZ_GENERATION": 4,
                              "PENDING_QUIZ_ANSWERS": 5,
                              "COMPLETE_WRONG_ANSWERS": 6,
                              "ERROR": 7,
                              "CANCELED": 8
                            }
                          },
                          "Error": {
                            "fields": {
                              "reason": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "type": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "IdentityIrregularity": {
                            "values": {
                              "IRREGULARITIES_DO_NOT_USE": 0,
                              "DECEASED": 1,
                              "AGE_BELOW_MINIMUM": 2,
                              "OVERUSED_IDENTITY": 3,
                              "US_SSN_ISSUED_BEFORE_DOB": 4,
                              "DOB_MISMATCH": 5,
                              "INVALID_US_SSN": 6,
                              "FAILED_EQUIFAX_CREDIT_CHECK": 9,
                              "FAILED_EXPERIAN_CREDIT_CHECK": 10,
                              "INVALID_DOB": 11,
                              "ADDRESS_IS_PO_BOX": 12,
                              "ADDRESS_IS_GENERAL_DELIVERY": 13,
                              "FAILED_TRULIOO_CREDIT_CHECK": 14,
                              "MISKEYED_NAME": 15,
                              "FAILED_FINTRAC_CREDIT_CHECK": 16
                            }
                          },
                          "Attribute": {
                            "fields": {
                              "type": {
                                "type": ".squareup.legalentities.verification.VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.Attribute.Type",
                                "id": 1,
                                "rule": "optional"
                              },
                              "matchStrength": {
                                "type": ".squareup.legalentities.verification.VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.Attribute.MatchStrength",
                                "id": 2,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "Type": {
                                "values": {
                                  "KEY_DO_NOT_USE": 0,
                                  "NAME": 1,
                                  "DATE_OF_BIRTH": 2,
                                  "ADDRESS": 3,
                                  "US_SSN": 4,
                                  "CA_SIN": 5,
                                  "DOCUMENT_IDENTIFIER": 6,
                                  "BANK_ACCOUNT": 7,
                                  "BANK_ACCOUNT_NAME": 8,
                                  "POSTAL_CODE": 9,
                                  "PHONE_NUMBER": 10,
                                  "GOVERNMENT_DATA": 11
                                }
                              },
                              "MatchStrength": {
                                "values": {
                                  "UNKNOWN": 0,
                                  "UNMATCHED": 1,
                                  "EXACT": 2,
                                  "FUZZY": 3
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  "signal": {
                    "oneof": ["manualReviewSignal", "informationRequiredSignal", "ofacSignal", "riskSignal", "idvSignal", "legacySignal", "provisionalSignal", "agreementsSignal", "complianceSignal", "acceptanceSignal", "requestMetadataSignal", "bankDepositSignal", "tinVerificationSignal", "docIdvSessionsSignal", "businessVerificationSignal", "attributeMatchingSessionsSignal", "productLevelHardblockSignal"]
                  }
                }
              },
              "VerificationDecision": {
                "fields": {
                  "structureToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "structureVersionToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "product": {
                    "type": ".squareup.legalentities.verification.Product",
                    "id": 3,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.legalentities.verification.VerificationDecision.Status",
                    "id": 4,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 5,
                    "rule": "optional"
                  },
                  "sequence": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": ".squareup.legalentities.verification.VerificationDecision.Reason",
                    "id": 7,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Status": {
                    "values": {
                      "STATUS_NOT_SET": 0,
                      "UNVERIFIED": 1,
                      "VERIFICATION_IN_PROGRESS": 2,
                      "PROVISIONALLY_VERIFIED": 7,
                      "VERIFIED": 3,
                      "UNDER_REVIEW": 4,
                      "CUSTOMER_INFO_REQUIRED": 5,
                      "SUSPENDED": 6
                    }
                  },
                  "Reason": {
                    "values": {
                      "OTHER": 0,
                      "MANUAL_REVIEW": 1,
                      "COMPLIANCE": 2,
                      "RISK": 3,
                      "IDV": 4,
                      "LEGACY": 5,
                      "PROVISIONAL": 6,
                      "ACCEPTANCE": 7,
                      "BANK_DEPOSIT": 8,
                      "NO_DATA": 9,
                      "TIN_VERIFICATION": 10,
                      "DOC_IDV": 11,
                      "BUSINESS_VERIFICATION": 12
                    }
                  }
                }
              },
              "IDVStrategy": {
                "values": {
                  "DO_NOT_USE": 0,
                  "ATTRIBUTE_VERIFICATION": 1,
                  "DOCUMENT_VERIFICATION": 2,
                  "INTERNAL_VERIFICATION": 3
                }
              },
              "IdvAttemptCounter": {
                "fields": {
                  "nodeToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "remainingRetryAttempts": {
                    "type": "sint32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "businessVerificationAttempts": {
                    "type": "sint32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "attributeMatchingAttempts": {
                    "type": "sint32",
                    "id": 4,
                    "rule": "optional"
                  },
                  "docIdvAttempts": {
                    "type": "sint32",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "ProductLevelHardblockCheck": {
                "fields": {
                  "state": {
                    "type": ".squareup.legalentities.verification.ProductLevelHardblockCheck.State",
                    "id": 1,
                    "rule": "optional"
                  },
                  "shouldBlock": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "State": {
                    "values": {
                      "STATE_DO_NOT_USE": 1,
                      "IN_PROGRESS": 2,
                      "COMPLETE": 3,
                      "ERROR": 4,
                      "TIMED_OUT": 5
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.Product && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.Tier && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.ManualReview && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.ManualReview?.nested?.Decision && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.ManualReview?.nested?.ProductReview && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.InformationRequired && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.InformationRequired?.nested?.Decision && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.OfacScreen && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.OfacScreen?.nested?.Decision && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.Risk && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.Risk?.nested?.Decision && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.Risk?.nested?.State && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.State && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.Result && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.Result?.nested?.IdentityverifierResult && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.Result?.nested?.IdmatchError && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.Result?.nested?.IdentityIrregularity && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.Result?.nested?.Attribute && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.Result?.nested?.Attribute?.nested?.Type && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.Result?.nested?.Attribute?.nested?.Match && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.Result?.nested?.Attribute?.nested?.MatchStrength && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.Decision && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.ProductDecision && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.ProductDecision?.nested?.IndividualEntry && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.ProductDecision?.nested?.IndividualEntry?.nested?.Reason && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.ProductDecision?.nested?.IndividualEntry?.nested?.Reason?.nested?.Code && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.ProductDecision?.nested?.IndividualEntry?.nested?.RuleEvaluation && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.ProductDecision?.nested?.IndividualEntry?.nested?.RuleEvaluation?.nested?.Code && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.ProductDecision?.nested?.RequestFlag && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.ProductDecision?.nested?.UnderReviewReason && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.ProductDecision?.nested?.UnderReviewReason?.nested?.UnderReviewReasonType && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.ProductDecision?.nested?.VerificationDecisionEvaluations && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.ProductDecision?.nested?.VerificationDecisionEvaluations?.nested?.VerificationDecisionEvaluationsReason && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.IdentityVerification?.nested?.ProductDecision?.nested?.VerificationDecisionEvaluations?.nested?.VerificationDecisionEvaluationsReason?.nested?.Status && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.Legacy && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.Provisional && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.Provisional?.nested?.Pending && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.Provisional?.nested?.Started && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.Provisional?.nested?.Terminated && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.Provisional?.nested?.Terminated?.nested?.Cause && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.Agreements && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.Agreements?.nested?.Agreement && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.Compliance && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.Compliance?.nested?.Decision && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.Compliance?.nested?.ProductDecision && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.Compliance?.nested?.State && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.Acceptance && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.Acceptance?.nested?.Decision && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.RequestMetadata && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.RequestMetadata?.nested?.Onboard && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.RequestMetadata?.nested?.Onboard?.nested?.Business && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.RequestMetadata?.nested?.Onboard?.nested?.Client && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.BankDeposit && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.BankDeposit?.nested?.Decision && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.BankDeposit?.nested?.State && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.TinVerification && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.TinVerification?.nested?.State && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.TinVerification?.nested?.Decision && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.TinVerification?.nested?.Result && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.BusinessVerification && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.BusinessVerification?.nested?.State && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.BusinessVerification?.nested?.BusinessVerificationState && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.BusinessVerification?.nested?.BusinessVerificationState?.nested?.ProductDecision && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.BusinessVerification?.nested?.BusinessVerificationState?.nested?.ProductDecision?.nested?.Decision && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.BusinessVerification?.nested?.BusinessVerificationState?.nested?.ProductDecision?.nested?.Decision?.nested?.Type && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.BusinessVerification?.nested?.BusinessVerificationState?.nested?.ProductDecision?.nested?.Decision?.nested?.Status && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.BusinessVerification?.nested?.BusinessVerificationState?.nested?.ProductDecision?.nested?.Decision?.nested?.Attribute && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.BusinessVerification?.nested?.BusinessVerificationState?.nested?.ProductDecision?.nested?.Decision?.nested?.MatchType && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.BusinessVerification?.nested?.BusinessVerificationState?.nested?.ProductDecision?.nested?.Status && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.DocIdvSessions && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.DocIdvSessions?.nested?.DocIdvSession && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.DocIdvSessions?.nested?.DocIdvSession?.nested?.State && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.AttributeMatchingSessions && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.AttributeMatchingSessions?.nested?.AttributeMatchingSession && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.AttributeMatchingSessions?.nested?.AttributeMatchingSession?.nested?.State && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.AttributeMatchingSessions?.nested?.AttributeMatchingSession?.nested?.Error && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.AttributeMatchingSessions?.nested?.AttributeMatchingSession?.nested?.IdentityIrregularity && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.AttributeMatchingSessions?.nested?.AttributeMatchingSession?.nested?.Attribute && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.AttributeMatchingSessions?.nested?.AttributeMatchingSession?.nested?.Attribute?.nested?.Type && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationSignal?.nested?.AttributeMatchingSessions?.nested?.AttributeMatchingSession?.nested?.Attribute?.nested?.MatchStrength && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationDecision && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationDecision?.nested?.Status && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.VerificationDecision?.nested?.Reason && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.IDVStrategy && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.IdvAttemptCounter && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.ProductLevelHardblockCheck && !$root.nested?.squareup?.nested?.legalentities?.nested?.verification?.nested?.ProductLevelHardblockCheck?.nested?.State) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Product @ squareup/legalentities/verification/verification.proto at 13:1
 */
export const Product = $root.lookupEnum('squareup.legalentities.verification.Product').values;
/**
 * SOURCE Tier @ squareup/legalentities/verification/verification.proto at 28:1
 */
export const Tier = $root.lookupEnum('squareup.legalentities.verification.Tier').values;
/**
 * SOURCE VerificationSignal @ squareup/legalentities/verification/verification.proto at 50:1
 */
export const VerificationSignal = $root.lookupType('squareup.legalentities.verification.VerificationSignal');
fixType(VerificationSignal);
Builder.createAndAttachToType(VerificationSignal);
/**
 * Verification decision produced by a human, typically from Compliance.
 *
 * SOURCE ManualReview @ squareup/legalentities/verification/verification.proto at 82:3
 */
VerificationSignal.ManualReview = $root.lookupType('squareup.legalentities.verification.VerificationSignal.ManualReview');
fixType(VerificationSignal.ManualReview);
Builder.createAndAttachToType(VerificationSignal.ManualReview);
/**
 * SOURCE Decision @ squareup/legalentities/verification/verification.proto at 92:5
 */
VerificationSignal.ManualReview.Decision = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.ManualReview.Decision').values;
/**
 * SOURCE ProductReview @ squareup/legalentities/verification/verification.proto at 99:5
 */
VerificationSignal.ManualReview.ProductReview = $root.lookupType('squareup.legalentities.verification.VerificationSignal.ManualReview.ProductReview');
fixType(VerificationSignal.ManualReview.ProductReview);
Builder.createAndAttachToType(VerificationSignal.ManualReview.ProductReview);
/**
 * SOURCE InformationRequired @ squareup/legalentities/verification/verification.proto at 111:3
 */
VerificationSignal.InformationRequired = $root.lookupType('squareup.legalentities.verification.VerificationSignal.InformationRequired');
fixType(VerificationSignal.InformationRequired);
Builder.createAndAttachToType(VerificationSignal.InformationRequired);
/**
 * SOURCE Decision @ squareup/legalentities/verification/verification.proto at 116:5
 */
VerificationSignal.InformationRequired.Decision = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.InformationRequired.Decision').values;
/**
 * SOURCE OfacScreen @ squareup/legalentities/verification/verification.proto at 123:3
 */
VerificationSignal.OfacScreen = $root.lookupType('squareup.legalentities.verification.VerificationSignal.OfacScreen');
fixType(VerificationSignal.OfacScreen);
Builder.createAndAttachToType(VerificationSignal.OfacScreen);
/**
 * SOURCE Decision @ squareup/legalentities/verification/verification.proto at 127:5
 */
VerificationSignal.OfacScreen.Decision = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.OfacScreen.Decision').values;
/**
 * SOURCE Risk @ squareup/legalentities/verification/verification.proto at 136:3
 */
VerificationSignal.Risk = $root.lookupType('squareup.legalentities.verification.VerificationSignal.Risk');
fixType(VerificationSignal.Risk);
Builder.createAndAttachToType(VerificationSignal.Risk);
/**
 * SOURCE Decision @ squareup/legalentities/verification/verification.proto at 143:5
 */
VerificationSignal.Risk.Decision = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.Risk.Decision').values;
/**
 * SOURCE State @ squareup/legalentities/verification/verification.proto at 163:5
 */
VerificationSignal.Risk.State = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.Risk.State').values;
/**
 * SOURCE IdentityVerification @ squareup/legalentities/verification/verification.proto at 171:3
 */
VerificationSignal.IdentityVerification = $root.lookupType('squareup.legalentities.verification.VerificationSignal.IdentityVerification');
fixType(VerificationSignal.IdentityVerification);
Builder.createAndAttachToType(VerificationSignal.IdentityVerification);
/**
 * SOURCE State @ squareup/legalentities/verification/verification.proto at 185:5
 */
VerificationSignal.IdentityVerification.State = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.IdentityVerification.State').values;
/**
 * Identity verification result (with tokens for audit trail) for an individual within the LE
 * structure. Contains all attributes used for verification, along with their match results.
 *
 * SOURCE Result @ squareup/legalentities/verification/verification.proto at 193:5
 */
VerificationSignal.IdentityVerification.Result = $root.lookupType('squareup.legalentities.verification.VerificationSignal.IdentityVerification.Result');
fixType(VerificationSignal.IdentityVerification.Result);
Builder.createAndAttachToType(VerificationSignal.IdentityVerification.Result);
/**
 * SOURCE IdentityverifierResult @ squareup/legalentities/verification/verification.proto at 238:7
 */
VerificationSignal.IdentityVerification.Result.IdentityverifierResult = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.IdentityVerification.Result.IdentityverifierResult').values;
/**
 * SOURCE IdmatchError @ squareup/legalentities/verification/verification.proto at 247:7
 */
VerificationSignal.IdentityVerification.Result.IdmatchError = $root.lookupType('squareup.legalentities.verification.VerificationSignal.IdentityVerification.Result.IdmatchError');
fixType(VerificationSignal.IdentityVerification.Result.IdmatchError);
Builder.createAndAttachToType(VerificationSignal.IdentityVerification.Result.IdmatchError);
/**
 * SOURCE IdentityIrregularity @ squareup/legalentities/verification/verification.proto at 252:7
 */
VerificationSignal.IdentityVerification.Result.IdentityIrregularity = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.IdentityVerification.Result.IdentityIrregularity').values;
/**
 * SOURCE Attribute @ squareup/legalentities/verification/verification.proto at 273:7
 */
VerificationSignal.IdentityVerification.Result.Attribute = $root.lookupType('squareup.legalentities.verification.VerificationSignal.IdentityVerification.Result.Attribute');
fixType(VerificationSignal.IdentityVerification.Result.Attribute);
Builder.createAndAttachToType(VerificationSignal.IdentityVerification.Result.Attribute);
/**
 * List of possible attributes.
 *
 * SOURCE Type @ squareup/legalentities/verification/verification.proto at 284:9
 */
VerificationSignal.IdentityVerification.Result.Attribute.Type = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.IdentityVerification.Result.Attribute.Type').values;
/**
 * List of possible match results.
 *
 * SOURCE Match @ squareup/legalentities/verification/verification.proto at 300:9
 */
VerificationSignal.IdentityVerification.Result.Attribute.Match = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.IdentityVerification.Result.Attribute.Match').values;
/**
 * List of possible match strengths.
 *
 * SOURCE MatchStrength @ squareup/legalentities/verification/verification.proto at 310:9
 */
VerificationSignal.IdentityVerification.Result.Attribute.MatchStrength = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.IdentityVerification.Result.Attribute.MatchStrength').values;
/**
 * SOURCE Decision @ squareup/legalentities/verification/verification.proto at 326:5
 */
VerificationSignal.IdentityVerification.Decision = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.IdentityVerification.Decision').values;
/**
 * SOURCE ProductDecision @ squareup/legalentities/verification/verification.proto at 337:5
 */
VerificationSignal.IdentityVerification.ProductDecision = $root.lookupType('squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision');
fixType(VerificationSignal.IdentityVerification.ProductDecision);
Builder.createAndAttachToType(VerificationSignal.IdentityVerification.ProductDecision);
/**
 * SOURCE IndividualEntry @ squareup/legalentities/verification/verification.proto at 347:7
 */
VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry = $root.lookupType('squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry');
fixType(VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry);
Builder.createAndAttachToType(VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry);
/**
 * SOURCE Reason @ squareup/legalentities/verification/verification.proto at 354:9
 */
VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry.Reason = $root.lookupType('squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry.Reason');
fixType(VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry.Reason);
Builder.createAndAttachToType(VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry.Reason);
/**
 * SOURCE Code @ squareup/legalentities/verification/verification.proto at 361:11
 */
VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry.Reason.Code = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry.Reason.Code').values;
/**
 * SOURCE RuleEvaluation @ squareup/legalentities/verification/verification.proto at 435:9
 */
VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry.RuleEvaluation = $root.lookupType('squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry.RuleEvaluation');
fixType(VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry.RuleEvaluation);
Builder.createAndAttachToType(VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry.RuleEvaluation);
/**
 * SOURCE Code @ squareup/legalentities/verification/verification.proto at 439:11
 */
VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry.RuleEvaluation.Code = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.IndividualEntry.RuleEvaluation.Code').values;
/**
 * SOURCE RequestFlag @ squareup/legalentities/verification/verification.proto at 451:7
 */
VerificationSignal.IdentityVerification.ProductDecision.RequestFlag = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.RequestFlag').values;
/**
 * SOURCE UnderReviewReason @ squareup/legalentities/verification/verification.proto at 461:7
 */
VerificationSignal.IdentityVerification.ProductDecision.UnderReviewReason = $root.lookupType('squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.UnderReviewReason');
fixType(VerificationSignal.IdentityVerification.ProductDecision.UnderReviewReason);
Builder.createAndAttachToType(VerificationSignal.IdentityVerification.ProductDecision.UnderReviewReason);
/**
 * SOURCE UnderReviewReasonType @ squareup/legalentities/verification/verification.proto at 465:9
 */
VerificationSignal.IdentityVerification.ProductDecision.UnderReviewReason.UnderReviewReasonType = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.UnderReviewReason.UnderReviewReasonType').values;
/**
 * SOURCE VerificationDecisionEvaluations @ squareup/legalentities/verification/verification.proto at 542:7
 */
VerificationSignal.IdentityVerification.ProductDecision.VerificationDecisionEvaluations = $root.lookupType('squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.VerificationDecisionEvaluations');
fixType(VerificationSignal.IdentityVerification.ProductDecision.VerificationDecisionEvaluations);
Builder.createAndAttachToType(VerificationSignal.IdentityVerification.ProductDecision.VerificationDecisionEvaluations);
/**
 * SOURCE VerificationDecisionEvaluationsReason @ squareup/legalentities/verification/verification.proto at 546:9
 */
VerificationSignal.IdentityVerification.ProductDecision.VerificationDecisionEvaluations.VerificationDecisionEvaluationsReason = $root.lookupType('squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.VerificationDecisionEvaluations.VerificationDecisionEvaluationsReason');
fixType(VerificationSignal.IdentityVerification.ProductDecision.VerificationDecisionEvaluations.VerificationDecisionEvaluationsReason);
Builder.createAndAttachToType(VerificationSignal.IdentityVerification.ProductDecision.VerificationDecisionEvaluations.VerificationDecisionEvaluationsReason);
/**
 * SOURCE Status @ squareup/legalentities/verification/verification.proto at 550:11
 */
VerificationSignal.IdentityVerification.ProductDecision.VerificationDecisionEvaluations.VerificationDecisionEvaluationsReason.Status = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.IdentityVerification.ProductDecision.VerificationDecisionEvaluations.VerificationDecisionEvaluationsReason.Status').values;
/**
 * A Legacy signal is used to represent verification evidence originating from older systems that
 * cannot otherwise be represented using other signal types. This should only be used as a last
 * resort when backfilling. New Legal Entities should never have this signal type.
 * This signal type is currently only in use for POS payments decisions generated in onboard
 *
 * SOURCE Legacy @ squareup/legalentities/verification/verification.proto at 567:3
 */
VerificationSignal.Legacy = $root.lookupType('squareup.legalentities.verification.VerificationSignal.Legacy');
fixType(VerificationSignal.Legacy);
Builder.createAndAttachToType(VerificationSignal.Legacy);
/**
 * SOURCE Provisional @ squareup/legalentities/verification/verification.proto at 578:3
 */
VerificationSignal.Provisional = $root.lookupType('squareup.legalentities.verification.VerificationSignal.Provisional');
fixType(VerificationSignal.Provisional);
Builder.createAndAttachToType(VerificationSignal.Provisional);
/**
 * Provisional status has been enabled but no activity in any account related to this legal
 * entity has taken place yet.
 *
 * The explicit distinction between `Pending` and `Started` is due to product requirements
 * to start the provisional mode countdown timer only when certain actions take place (vs
 * immediately, upon provisional activation).
 *
 * SOURCE Pending @ squareup/legalentities/verification/verification.proto at 593:5
 */
VerificationSignal.Provisional.Pending = $root.lookupType('squareup.legalentities.verification.VerificationSignal.Provisional.Pending');
fixType(VerificationSignal.Provisional.Pending);
Builder.createAndAttachToType(VerificationSignal.Provisional.Pending);
/**
 * Provisional status has been triggered by an action in any of the accounts related to this
 * legal entity.
 *
 * Example: Provisional Activation for PAYMENTS is expires 7-days after the 1st payment or after
 * the payment limit is hit. For this case, a Provisional signal would be created in
 * `Pending` state and transitioned into `Started` state at time of 1st payment, automatically
 * being moved to `Terminated` 7 days later (or sooner, if the card processing limit were
 * to be reached).
 *
 * SOURCE Started @ squareup/legalentities/verification/verification.proto at 606:5
 */
VerificationSignal.Provisional.Started = $root.lookupType('squareup.legalentities.verification.VerificationSignal.Provisional.Started');
fixType(VerificationSignal.Provisional.Started);
Builder.createAndAttachToType(VerificationSignal.Provisional.Started);
/**
 * Provisional status has been terminated.
 *
 * SOURCE Terminated @ squareup/legalentities/verification/verification.proto at 617:5
 */
VerificationSignal.Provisional.Terminated = $root.lookupType('squareup.legalentities.verification.VerificationSignal.Provisional.Terminated');
fixType(VerificationSignal.Provisional.Terminated);
Builder.createAndAttachToType(VerificationSignal.Provisional.Terminated);
/**
 * Possible causes for termination of provisional status.
 *
 * SOURCE Cause @ squareup/legalentities/verification/verification.proto at 629:7
 */
VerificationSignal.Provisional.Terminated.Cause = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.Provisional.Terminated.Cause').values;
/**
 * SOURCE Agreements @ squareup/legalentities/verification/verification.proto at 658:3
 */
VerificationSignal.Agreements = $root.lookupType('squareup.legalentities.verification.VerificationSignal.Agreements');
fixType(VerificationSignal.Agreements);
Builder.createAndAttachToType(VerificationSignal.Agreements);
/**
 * SOURCE Agreement @ squareup/legalentities/verification/verification.proto at 661:5
 */
VerificationSignal.Agreements.Agreement = $root.lookupType('squareup.legalentities.verification.VerificationSignal.Agreements.Agreement');
fixType(VerificationSignal.Agreements.Agreement);
Builder.createAndAttachToType(VerificationSignal.Agreements.Agreement);
/**
 * Signal created by Compliance to suspend an account.
 *
 * Account suspensions could happen for a variety of reasons. Details are not collected on the
 * decision reasoning because it is considered secret information.
 *
 * SOURCE Compliance @ squareup/legalentities/verification/verification.proto at 675:3
 */
VerificationSignal.Compliance = $root.lookupType('squareup.legalentities.verification.VerificationSignal.Compliance');
fixType(VerificationSignal.Compliance);
Builder.createAndAttachToType(VerificationSignal.Compliance);
/**
 * SOURCE Decision @ squareup/legalentities/verification/verification.proto at 682:5
 */
VerificationSignal.Compliance.Decision = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.Compliance.Decision').values;
/**
 * SOURCE ProductDecision @ squareup/legalentities/verification/verification.proto at 693:5
 */
VerificationSignal.Compliance.ProductDecision = $root.lookupType('squareup.legalentities.verification.VerificationSignal.Compliance.ProductDecision');
fixType(VerificationSignal.Compliance.ProductDecision);
Builder.createAndAttachToType(VerificationSignal.Compliance.ProductDecision);
/**
 * SOURCE State @ squareup/legalentities/verification/verification.proto at 715:5
 */
VerificationSignal.Compliance.State = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.Compliance.State').values;
/**
 * Acceptance signal to suspend an account. Used for SMCC in JP
 *
 * SOURCE Acceptance @ squareup/legalentities/verification/verification.proto at 732:3
 */
VerificationSignal.Acceptance = $root.lookupType('squareup.legalentities.verification.VerificationSignal.Acceptance');
fixType(VerificationSignal.Acceptance);
Builder.createAndAttachToType(VerificationSignal.Acceptance);
/**
 * SOURCE Decision @ squareup/legalentities/verification/verification.proto at 735:5
 */
VerificationSignal.Acceptance.Decision = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.Acceptance.Decision').values;
/**
 * Miscellaneous data about the most recent request to verify the legal entity. Data here is not
 * a defining characteristic of the business or its related individuals, but it could be useful
 * during a verification.
 *
 * SOURCE RequestMetadata @ squareup/legalentities/verification/verification.proto at 750:3
 */
VerificationSignal.RequestMetadata = $root.lookupType('squareup.legalentities.verification.VerificationSignal.RequestMetadata');
fixType(VerificationSignal.RequestMetadata);
Builder.createAndAttachToType(VerificationSignal.RequestMetadata);
/**
 * Data collected by the onboard service for signing up Square POS/Terminal merchants.
 * Initially derived from squareup.beacon.service.OnboardActivationData.
 *
 * SOURCE Onboard @ squareup/legalentities/verification/verification.proto at 753:5
 */
VerificationSignal.RequestMetadata.Onboard = $root.lookupType('squareup.legalentities.verification.VerificationSignal.RequestMetadata.Onboard');
fixType(VerificationSignal.RequestMetadata.Onboard);
Builder.createAndAttachToType(VerificationSignal.RequestMetadata.Onboard);
/**
 * Information about the business that was entered during signup. This does not necessarily
 * match data in any of the platform account's payconfigs.
 *
 * SOURCE Business @ squareup/legalentities/verification/verification.proto at 756:7
 */
VerificationSignal.RequestMetadata.Onboard.Business = $root.lookupType('squareup.legalentities.verification.VerificationSignal.RequestMetadata.Onboard.Business');
fixType(VerificationSignal.RequestMetadata.Onboard.Business);
Builder.createAndAttachToType(VerificationSignal.RequestMetadata.Onboard.Business);
/**
 * Information about the client communicating with onboard
 *
 * SOURCE Client @ squareup/legalentities/verification/verification.proto at 764:7
 */
VerificationSignal.RequestMetadata.Onboard.Client = $root.lookupType('squareup.legalentities.verification.VerificationSignal.RequestMetadata.Onboard.Client');
fixType(VerificationSignal.RequestMetadata.Onboard.Client);
Builder.createAndAttachToType(VerificationSignal.RequestMetadata.Onboard.Client);
/**
 *  Bank deposit signal use to approve from bank deposit information and business type
 *
 * SOURCE BankDeposit @ squareup/legalentities/verification/verification.proto at 790:3
 */
VerificationSignal.BankDeposit = $root.lookupType('squareup.legalentities.verification.VerificationSignal.BankDeposit');
fixType(VerificationSignal.BankDeposit);
Builder.createAndAttachToType(VerificationSignal.BankDeposit);
/**
 * SOURCE Decision @ squareup/legalentities/verification/verification.proto at 794:5
 */
VerificationSignal.BankDeposit.Decision = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.BankDeposit.Decision').values;
/**
 * SOURCE State @ squareup/legalentities/verification/verification.proto at 805:5
 */
VerificationSignal.BankDeposit.State = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.BankDeposit.State').values;
/**
 * Tin verification signal contains data about TIN/SSN validation
 *
 * SOURCE TinVerification @ squareup/legalentities/verification/verification.proto at 813:3
 */
VerificationSignal.TinVerification = $root.lookupType('squareup.legalentities.verification.VerificationSignal.TinVerification');
fixType(VerificationSignal.TinVerification);
Builder.createAndAttachToType(VerificationSignal.TinVerification);
/**
 * SOURCE State @ squareup/legalentities/verification/verification.proto at 821:5
 */
VerificationSignal.TinVerification.State = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.TinVerification.State').values;
/**
 * SOURCE Decision @ squareup/legalentities/verification/verification.proto at 831:5
 */
VerificationSignal.TinVerification.Decision = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.TinVerification.Decision').values;
/**
 * SOURCE Result @ squareup/legalentities/verification/verification.proto at 837:5
 */
VerificationSignal.TinVerification.Result = $root.lookupType('squareup.legalentities.verification.VerificationSignal.TinVerification.Result');
fixType(VerificationSignal.TinVerification.Result);
Builder.createAndAttachToType(VerificationSignal.TinVerification.Result);
/**
 * Business verification signal contains data about Business information validation
 *
 * SOURCE BusinessVerification @ squareup/legalentities/verification/verification.proto at 847:3
 */
VerificationSignal.BusinessVerification = $root.lookupType('squareup.legalentities.verification.VerificationSignal.BusinessVerification');
fixType(VerificationSignal.BusinessVerification);
Builder.createAndAttachToType(VerificationSignal.BusinessVerification);
/**
 * SOURCE State @ squareup/legalentities/verification/verification.proto at 854:5
 */
VerificationSignal.BusinessVerification.State = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.BusinessVerification.State').values;
/**
 * SOURCE BusinessVerificationState @ squareup/legalentities/verification/verification.proto at 861:5
 */
VerificationSignal.BusinessVerification.BusinessVerificationState = $root.lookupType('squareup.legalentities.verification.VerificationSignal.BusinessVerification.BusinessVerificationState');
fixType(VerificationSignal.BusinessVerification.BusinessVerificationState);
Builder.createAndAttachToType(VerificationSignal.BusinessVerification.BusinessVerificationState);
/**
 * SOURCE ProductDecision @ squareup/legalentities/verification/verification.proto at 865:7
 */
VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision = $root.lookupType('squareup.legalentities.verification.VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision');
fixType(VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision);
Builder.createAndAttachToType(VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision);
/**
 * SOURCE Decision @ squareup/legalentities/verification/verification.proto at 875:9
 */
VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Decision = $root.lookupType('squareup.legalentities.verification.VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Decision');
fixType(VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Decision);
Builder.createAndAttachToType(VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Decision);
/**
 * SOURCE Type @ squareup/legalentities/verification/verification.proto at 903:11
 */
VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Decision.Type = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Decision.Type').values;
/**
 * SOURCE Status @ squareup/legalentities/verification/verification.proto at 911:11
 */
VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Decision.Status = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Decision.Status').values;
/**
 * SOURCE Attribute @ squareup/legalentities/verification/verification.proto at 919:11
 */
VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Decision.Attribute = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Decision.Attribute').values;
/**
 * SOURCE MatchType @ squareup/legalentities/verification/verification.proto at 945:11
 */
VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Decision.MatchType = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Decision.MatchType').values;
/**
 * SOURCE Status @ squareup/legalentities/verification/verification.proto at 952:9
 */
VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Status = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.BusinessVerification.BusinessVerificationState.ProductDecision.Status').values;
/**
 * SOURCE DocIdvSessions @ squareup/legalentities/verification/verification.proto at 963:3
 */
VerificationSignal.DocIdvSessions = $root.lookupType('squareup.legalentities.verification.VerificationSignal.DocIdvSessions');
fixType(VerificationSignal.DocIdvSessions);
Builder.createAndAttachToType(VerificationSignal.DocIdvSessions);
/**
 * SOURCE DocIdvSession @ squareup/legalentities/verification/verification.proto at 969:5
 */
VerificationSignal.DocIdvSessions.DocIdvSession = $root.lookupType('squareup.legalentities.verification.VerificationSignal.DocIdvSessions.DocIdvSession');
fixType(VerificationSignal.DocIdvSessions.DocIdvSession, {
  nodeToken: {
    notEmpty: true
  },
  verificationId: {
    notEmpty: true
  },
  vendorName: {
    notEmpty: true
  },
  product: {
    required: true
  }
});
Builder.createAndAttachToType(VerificationSignal.DocIdvSessions.DocIdvSession);
/**
 * SOURCE State @ squareup/legalentities/verification/verification.proto at 1006:7
 */
VerificationSignal.DocIdvSessions.DocIdvSession.State = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.DocIdvSessions.DocIdvSession.State').values;
/**
 * SOURCE AttributeMatchingSessions @ squareup/legalentities/verification/verification.proto at 1024:3
 */
VerificationSignal.AttributeMatchingSessions = $root.lookupType('squareup.legalentities.verification.VerificationSignal.AttributeMatchingSessions');
fixType(VerificationSignal.AttributeMatchingSessions);
Builder.createAndAttachToType(VerificationSignal.AttributeMatchingSessions);
/**
 * SOURCE AttributeMatchingSession @ squareup/legalentities/verification/verification.proto at 1031:5
 */
VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession = $root.lookupType('squareup.legalentities.verification.VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession');
fixType(VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession, {
  nodeToken: {
    notEmpty: true
  },
  structureToken: {
    notEmpty: true
  },
  product: {
    required: true
  }
});
Builder.createAndAttachToType(VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession);
/**
 * SOURCE State @ squareup/legalentities/verification/verification.proto at 1081:7
 */
VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.State = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.State').values;
/**
 * SOURCE Error @ squareup/legalentities/verification/verification.proto at 1101:7
 */
VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.Error = $root.lookupType('squareup.legalentities.verification.VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.Error');
fixType(VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.Error);
Builder.createAndAttachToType(VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.Error);
/**
 * SOURCE IdentityIrregularity @ squareup/legalentities/verification/verification.proto at 1106:7
 */
VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.IdentityIrregularity = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.IdentityIrregularity').values;
/**
 * SOURCE Attribute @ squareup/legalentities/verification/verification.proto at 1127:7
 */
VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.Attribute = $root.lookupType('squareup.legalentities.verification.VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.Attribute');
fixType(VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.Attribute);
Builder.createAndAttachToType(VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.Attribute);
/**
 * List of possible attributes
 *
 * SOURCE Type @ squareup/legalentities/verification/verification.proto at 1134:9
 */
VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.Attribute.Type = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.Attribute.Type').values;
/**
 * List of possible match strengths
 *
 * SOURCE MatchStrength @ squareup/legalentities/verification/verification.proto at 1150:9
 */
VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.Attribute.MatchStrength = $root.lookupEnum('squareup.legalentities.verification.VerificationSignal.AttributeMatchingSessions.AttributeMatchingSession.Attribute.MatchStrength').values;
/**
 * High level details about the verification decision made for a given legal entity structure.
 *
 * SOURCE VerificationDecision @ squareup/legalentities/verification/verification.proto at 1168:1
 */
export const VerificationDecision = $root.lookupType('squareup.legalentities.verification.VerificationDecision');
fixType(VerificationDecision);
Builder.createAndAttachToType(VerificationDecision);
/**
 * Possible verification status for a Legal Entity.
 *
 * Disclaimer: Legal Entities defines these status values to reflect the current state of an
 * entity responsible for one (or more) accounts in Square's ecosystem but it does not enforce
 * side-effects (e.g. can accounts associated with a LE take payments or settle). Side-effects
 * are the responsibility of downstream dependencies and any examples provided in documentation
 * of states defined in this enum are illustrative.
 *
 * SOURCE Status @ squareup/legalentities/verification/verification.proto at 1199:3
 */
VerificationDecision.Status = $root.lookupEnum('squareup.legalentities.verification.VerificationDecision.Status').values;
/**
 * SOURCE Reason @ squareup/legalentities/verification/verification.proto at 1278:3
 */
VerificationDecision.Reason = $root.lookupEnum('squareup.legalentities.verification.VerificationDecision.Reason').values;
/**
 * SOURCE IDVStrategy @ squareup/legalentities/verification/verification.proto at 1344:1
 */
export const IDVStrategy = $root.lookupEnum('squareup.legalentities.verification.IDVStrategy').values;
/**
 * SOURCE IdvAttemptCounter @ squareup/legalentities/verification/verification.proto at 1351:1
 */
export const IdvAttemptCounter = $root.lookupType('squareup.legalentities.verification.IdvAttemptCounter');
fixType(IdvAttemptCounter);
Builder.createAndAttachToType(IdvAttemptCounter);
/**
 * SOURCE ProductLevelHardblockCheck @ squareup/legalentities/verification/verification.proto at 1359:1
 */
export const ProductLevelHardblockCheck = $root.lookupType('squareup.legalentities.verification.ProductLevelHardblockCheck');
fixType(ProductLevelHardblockCheck, {
  state: {
    required: true
  }
});
Builder.createAndAttachToType(ProductLevelHardblockCheck);
/**
 * SOURCE State @ squareup/legalentities/verification/verification.proto at 1363:3
 */
ProductLevelHardblockCheck.State = $root.lookupEnum('squareup.legalentities.verification.ProductLevelHardblockCheck.State').values;